import { getEnvConfig } from '@hbs-us/contracts';

import { getAppEnv } from '../../lib/env.js';

/**
 * Build the credentialed URL for the weekly-hours PDF (D-06 / T-22-export). The api host is NEVER
 * hardcoded — it comes from `@hbs-us/contracts` `getEnvConfig().domains.api` (the same source
 * apiFetch uses). The PDF is generated by the EXISTING server engine (generateWeeklyHoursPdf, reused
 * from the SSR admin export) — the SPA only links out; it never rebuilds the PDF client-side.
 *
 * Opened via `<a>` / new tab with the user's cookies (a safe GET read, no CSRF). The endpoint is
 * tenant-scoped server-side (SEC-11), so the link carries only the selected week.
 */

function apiBaseUrl(): string {
  return `https://${getEnvConfig(getAppEnv()).domains.api}`;
}

/** Credentialed weekly-hours PDF download for a week (api-host GET, reused engine). */
export function weeklyHoursPdfUrl(weekStart: string): string {
  return `${apiBaseUrl()}/api/v1/timesheets/weekly-hours/pdf?week=${encodeURIComponent(weekStart)}`;
}
